<div class="about">
    <div class="centered-container">
        <div class="help about">
            <button class="close" (click)="toggleAbout()">
                <span class="icon icon-ui-close"></span>
            </button>
            <h3>About PennDOT ETL</h3>
            <p>PETL (PennDOT ETL) is a service based toolset enabled by a web based application that provides a PennDOT
                GIS user with the ability to import data from a text file or Excel spreadsheet containing linear or
                point location references directly into a GIS-ready database table. Upon import, the data is enhanced
                with geometry for use in mapping applications. As such, PETL is a direct replacement for the desktop
                based GIS2000 application previously used to perform these functions. </p>
            <p>PETL enables users to import and display files directly on a map by dragging/dropping the file onto the
                map. It also improves the ease of mapping fields by enabling users to drag/drop columns from the
                imported file to the matching fields.</p>
        </div>
    </div>
</div>